module.exports = __webpack_public_path__ + "img/badge-list-thumb-010.18c854a5.png";